import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, vModelRadio as _vModelRadio, withDirectives as _withDirectives, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "produit-area" }
const _hoisted_2 = {
  key: 0,
  class: "page-space-50"
}
const _hoisted_3 = { class: "container-small" }
const _hoisted_4 = {
  class: "s10_mobile position-relative",
  style: {"height":"380px","display":"flex","justify-content":"center","align-items":"center"}
}
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "s9_mobile" }
const _hoisted_7 = { class: "secondary-font mt-5 mb-6" }
const _hoisted_8 = { class: "text-4xl secondary-font mb-5" }
const _hoisted_9 = ["for"]
const _hoisted_10 = { class: "s1 mt-1" }
const _hoisted_11 = ["id", "value"]
const _hoisted_12 = { class: "s14 pl-2 secondary-font" }
const _hoisted_13 = { class: "secondary-font text-grey-600" }
const _hoisted_14 = { class: "s5 text-right secondary-font" }
const _hoisted_15 = ["disabled"]
const _hoisted_16 = { class: "flex" }
const _hoisted_17 = ["innerHTML"]

import { formatAmount } from '@/utils/formatters';
import { computed, inject, onMounted, reactive, ref, toRaw } from 'vue';
import { useRouter } from 'vue-router';
import { useMarketCartStore } from '@/stores/cart.store';


export default /*@__PURE__*/_defineComponent({
  __name: 'ProduitsDetailsView',
  setup(__props) {

const BACKEND_URL = inject('BACKEND_URL');
const router = useRouter();
const cart = useMarketCartStore();
const layout = ref('none');
const loadingCart = ref(false);
const startupInfos = reactive({
    product: {} as any,
});
const echeancesPaiement = ref([] as any[]);
const formGroup = reactive({
    echeance_id: -1,
});
const currentMontant = computed(() => {
    const echeance = echeancesPaiement.value.find(e => e.value === formGroup.echeance_id);
    return echeance ? echeance.montant : startupInfos.product.montant;
});

onMounted(() => {
  layout.value = router.currentRoute.value.meta.layout as string || 'none';
  Object.assign(startupInfos, router.currentRoute.value.meta.startup_infos);
  echeancesPaiement.value = [
        {
            value: -1,
            label: 'Payer en une fois',
            description: 'Avec le solde de votre wallet',
            montant: startupInfos.product.montant,
        },
        ...startupInfos.product.echeances.map((echeance: any) => ({
            value: echeance.duration,
            label: `Payer en ${echeance.nombre_mensualites} fois`,
            description: `${formatAmount(echeance.montant_mensualite)} F CFA x ${echeance.nombre_mensualites}`,
            montant: echeance.montant_total,
        }))
    ];
});

function addToCart() {
    if (loadingCart.value) { return; }

    loadingCart.value = true;
    if (formGroup.echeance_id === -1) {
        cart.addToCart({
            id: startupInfos.product.id,
            nom: startupInfos.product.nom,
            montant: currentMontant.value,
            image: startupInfos.product.image,
            typePromotion: startupInfos.product.type_promotion,
            montantPromotion: startupInfos.product.montant_promotion,
            montantRemise: 0,
            sousTotal: 0,
            total: 0,
        });
    } else {
        const echeance = toRaw(echeancesPaiement.value).find(e => e.value === formGroup.echeance_id);
        if (echeance) {
            cart.addToCart({
                id: startupInfos.product.id,
                nom: startupInfos.product.nom,
                montant: currentMontant.value,
                image: startupInfos.product.image,
                typePromotion: startupInfos.product.type_promotion,
                montantPromotion: startupInfos.product.montant_promotion,
                echeance: echeance.value,
                montantRemise: 0,
                sousTotal: 0,
                total: 0
            });
        }
    }
    setTimeout(() => loadingCart.value = false, 2000);
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("main", null, [
    _createElementVNode("div", _hoisted_1, [
      (layout.value == 'none')
        ? (_openBlock(), _createElementBlock("div", _hoisted_2))
        : _createCommentVNode("", true),
      _createElementVNode("section", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _cache[1] || (_cache[1] = _createElementVNode("div", {
            class: "tag-set justify-content-left",
            style: {"top":"0"}
          }, [
            _createElementVNode("div", { class: "tag2" }, "-20%")
          ], -1)),
          _createElementVNode("img", {
            src: _unref(BACKEND_URL) + '/assets/market_produits/1000/' + startupInfos.product.image,
            style: {"max-width":"100%","max-height":"350px"}
          }, null, 8, _hoisted_5)
        ]),
        _cache[8] || (_cache[8] = _createElementVNode("div", { class: "s1_mobile" }, " ", -1)),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("h1", _hoisted_7, _toDisplayString(startupInfos.product.nom), 1),
          _createElementVNode("h1", _hoisted_8, _toDisplayString(_unref(formatAmount)(currentMontant.value)) + " F CFA ", 1),
          _cache[4] || (_cache[4] = _createElementVNode("div", { class: "h-0" }, null, -1)),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(echeancesPaiement.value, (echeance, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "card-check bg-white-50 widget active flex my-2 pt-6 pb-5 px-6",
              key: index
            }, [
              _createElementVNode("label", {
                class: "s20",
                for: 'echeance_' + index
              }, [
                _createElementVNode("div", _hoisted_10, [
                  _withDirectives(_createElementVNode("input", {
                    class: "",
                    type: "radio",
                    name: "echeance",
                    id: 'echeance_' + index,
                    value: echeance.value,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formGroup.echeance_id) = $event))
                  }, null, 8, _hoisted_11), [
                    [_vModelRadio, formGroup.echeance_id]
                  ])
                ]),
                _createElementVNode("h5", _hoisted_12, [
                  _createTextVNode(_toDisplayString(echeance.label) + " ", 1),
                  _cache[2] || (_cache[2] = _createElementVNode("br", { class: "mb-3" }, null, -1)),
                  _createElementVNode("span", _hoisted_13, _toDisplayString(echeance.description), 1)
                ]),
                _createElementVNode("h4", _hoisted_14, _toDisplayString(_unref(formatAmount)(echeance.montant)) + " F", 1)
              ], 8, _hoisted_9)
            ]))
          }), 128)),
          _cache[5] || (_cache[5] = _createElementVNode("div", { class: "clear-both h-20" }, null, -1)),
          _createElementVNode("button", {
            class: _normalizeClass(["btn-ultra lg w-100", {'loading': loadingCart.value}]),
            onClick: addToCart,
            disabled: loadingCart.value
          }, [...(_cache[3] || (_cache[3] = [
            _createElementVNode("div", { class: "btn-show" }, [
              _createElementVNode("img", {
                src: "/public/icons/icon-panier.svg",
                class: "btn-icon",
                alt: ""
              }),
              _createElementVNode("span", null, " Ajouter au panier")
            ], -1),
            _createElementVNode("div", { class: "btn-loading" }, [
              _createElementVNode("div", { class: "loader-dots" })
            ], -1)
          ]))], 10, _hoisted_15),
          _cache[6] || (_cache[6] = _createElementVNode("div", { class: "h-30" }, null, -1))
        ]),
        _cache[9] || (_cache[9] = _createElementVNode("div", { class: "clear-both h-10" }, null, -1)),
        _createElementVNode("div", _hoisted_16, [
          _createElementVNode("p", {
            class: "s10_mobile text-read",
            innerHTML: startupInfos.product.description
          }, null, 8, _hoisted_17),
          _cache[7] || (_cache[7] = _createStaticVNode("<div class=\"s1_mobile\"> </div><div class=\"s9_mobile\"><div class=\"mb-6 text-grey-700\"><hr><h5 class=\"mt-5 mb-2\">Caractéristiques principales :</h5><p>6,9 pouces Super Retina XDR avec ProMotion 120Hz</p></div><div class=\"mb-6 text-grey-700\"><hr><h5 class=\"mt-5 mb-2\">Caractéristiques principales :</h5><p>6,9 pouces Super Retina XDR avec ProMotion 120Hz</p></div></div>", 2))
        ])
      ]),
      _cache[10] || (_cache[10] = _createElementVNode("div", { class: "clear-both h-60" }, null, -1))
    ])
  ]))
}
}

})